// Module
var code = `<template class="instrument-lookup" mdc-menu-surface-anchor>
  <require from="./instrument-lookup.scss"></require>
  <mdc-text-field ref="input" label.bind="placeholder" view-model.ref="inputVM" disabled.bind="!initialised || disabled">
    <div mdc-text-field-icon trailing>
      <button mdc-icon-button click.trigger="add() & stopPropagation" if.bind="!value" icon="add" mdc-tooltip="Create Un Noted Instrument" tabindex="-1"></button>
      <button mdc-icon-button click.trigger="edit() & stopPropagation" if.bind="value && !hideEdit && !disabled" icon="edit" mdc-tooltip="Edit instrument" tabindex="-1"></button>
      <button mdc-icon-button click.trigger="clear() & stopPropagation" if.bind="value && !disabled" icon="clear" mdc-tooltip="Clear Selected Instrument" tabindex="-1"></button>
    </div>
  </mdc-text-field>
  <mdc-text-field-helper-line></mdc-text-field-helper-line>
  <div mdc-menu-surface="stay-open.bind: false; anchor.bind: input; anchor-corner: BOTTOM_LEFT; hoist-to-body: true; natural-width: false" mdc-menu-surface.ref="menuSurface" class="instrument-lookup__menu-surface">
    <mdc-list role="menu" wrap-focus view-model.ref="list" mdclist:action.trigger="select(\$event.detail.data)">
      <mdc-list-item if.bind="searching" no-list-action>Searching...</mdc-list-item>
      <mdc-list-item if.bind="errorMessage" no-list-action>\${errorMessage}</mdc-list-item>
      <mdc-list-item if.bind="groups && !groups.length" no-list-action>Not found</mdc-list-item>

      <div repeat.for="g of groups">
        <mdc-list-item mdclistitem:action.delegate="g.expanded = !g.expanded" no-list-action class="instrument-lookup__group-item">
          \${g.type}
          <mdc-icon mdc-list-item-trailing>\${g.expanded ? 'expand_less' :'expand_more'}</mdc-icon>
        </mdc-list-item>
        <div if.bind="g.expanded">
          <mdc-list-item role="menuitem" repeat.for="i of g.instruments" value.bind="i" two-line.bind="twoLine" value.bind="i" class="instrument-lookup__instrument-item">
            <div class="instrument-lookup__item-grid">
              <span class="name left-padding top-padding">\${i.name}</span>
              <span class="isin left-padding">\${i.isin}</span>
              <span class="ticker left-padding bottom-padding">\${i.ticker}</span>
              <span class="mic top-padding">\${i.mic}</span>
              <span class="currency bottom-padding">\${i.currencyCode}</span>
              <span class="existing top-padding" if.bind="i.existingInstrument !== undefined">
                \${i.existingInstrument ? '(E)' : '(NEW)'}
              </span>
            </div>
          </mdc-list-item>
        </div>
      </div>
    </mdc-list>
  </div>
</template>
`;
// Exports
export default code;